module.exports = {
  XLSX: 'xlsx',
  CSV: 'csv',
  PDF: 'pdf',
  OFX: 'ofx'
};
